import type { TopNavigationProps as NewTopNavigationProps } from './TopNavigation';

export interface OldTopNavigationProps extends Omit<NewTopNavigationProps, 'leftContent' | 'rightContent'> {
  /** @deprecated leftContent를 대신 사용해주세요. */
  left?: NewTopNavigationProps['leftContent'];
  /** @deprecated rightContent를 대신 사용해주세요. */
  right?: NewTopNavigationProps['rightContent'];
}

export function convertOldTopNavigationProps({ left, right, ...props }: OldTopNavigationProps): NewTopNavigationProps {
  return {
    ...props,
    leftContent: left,
    rightContent: right,
  };
}
